import { SVGProps } from 'react';

export const Compare = ({
  width = 20,
  height = 20,
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.75 16.25V3.75C8.75 3.40482 9.02982 3.125 9.375 3.125C9.72018 3.125 10 3.40482 10 3.75V16.25C10 16.5952 9.72018 16.875 9.375 16.875C9.02982 16.875 8.75 16.5952 8.75 16.25Z"
        fill="currentColor"
      />
      <path
        d="M17.5 14.2859V5.71411C17.5 5.67761 17.4944 5.6477 17.4878 5.625H11.875C11.5298 5.625 11.25 5.34518 11.25 5C11.25 4.65482 11.5298 4.375 11.875 4.375H17.6044C17.936 4.37506 18.2114 4.53365 18.4015 4.7467L18.4772 4.8407L18.5425 4.93958C18.6839 5.17538 18.75 5.44976 18.75 5.71411V14.2859C18.75 14.588 18.6636 14.9036 18.4772 15.1593C18.2885 15.4179 17.9832 15.6249 17.6044 15.625H11.875C11.5298 15.625 11.25 15.3452 11.25 15C11.25 14.6548 11.5298 14.375 11.875 14.375H17.4878C17.4944 14.3523 17.5 14.3224 17.5 14.2859Z"
        fill="currentColor"
      />
      <path
        d="M8.75 15.625H1.875C1.70924 15.625 1.55027 15.5403 1.43306 15.3896C1.31585 15.2389 1.25 15.0345 1.25 14.8214V5.17857C1.25 4.96545 1.31585 4.76106 1.43306 4.61036C1.55027 4.45966 1.70924 4.375 1.875 4.375H8.75"
        fill="currentColor"
      />
    </svg>
  );
};
